// extracted by mini-css-extract-plugin
export default {"box-shadow-contsiner":"Overview_box-shadow-contsiner__2Bje8","add_client_btn_overview":"Overview_add_client_btn_overview__1I-W0"};